import curry from 'lodash/curry';
import ToastType from '@/constants/ui/ToastType';
import showToastTypeMessage from './showToastTypeMessage';

const showErrorMessage = curry(showToastTypeMessage)(ToastType.ERROR);

export default showErrorMessage;
